module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12"
  }, [_c('div', {
    staticClass: "step-form__main"
  }, [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "brokerSubmitForm",
    staticClass: "step-form__form",
    attrs: {
      "model": _vm.brokerSubmitForm,
      "rules": _vm.rules
    }
  }, [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px",
      "margin-bottom": "30px"
    }
  }, [_vm._v("Business Information")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Company legal name *"
    },
    model: {
      value: (_vm.brokerSubmitForm.businessName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessName", $$v)
      },
      expression: "brokerSubmitForm.businessName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "tradeName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "DBA (If applicable)"
    },
    model: {
      value: (_vm.brokerSubmitForm.tradeName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "tradeName", $$v)
      },
      expression: "brokerSubmitForm.tradeName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessStreetAddress",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Address *",
      "maxlength": 40
    },
    model: {
      value: (_vm.brokerSubmitForm.businessStreetAddress),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessStreetAddress", $$v)
      },
      expression: "brokerSubmitForm.businessStreetAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessStreetAddressLine2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Address Line 2",
      "maxlength": 40
    },
    model: {
      value: (_vm.brokerSubmitForm.businessStreetAddressLine2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessStreetAddressLine2", $$v)
      },
      expression: "brokerSubmitForm.businessStreetAddressLine2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessCityName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "City *",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.businessCityName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessCityName", $$v)
      },
      expression: "brokerSubmitForm.businessCityName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "businessState",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state *"
    },
    model: {
      value: (_vm.brokerSubmitForm.businessState),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessState", $$v)
      },
      expression: "brokerSubmitForm.businessState"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Select state",
      "value": "",
      "disabled": ""
    }
  }), _vm._v(" "), _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessZip",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Zip *",
      "maxlength": 5
    },
    model: {
      value: (_vm.brokerSubmitForm.businessZip),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessZip", $$v)
      },
      expression: "brokerSubmitForm.businessZip"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessPhone",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Company phone *",
      "maxlength": 10
    },
    model: {
      value: (_vm.brokerSubmitForm.businessPhone),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessPhone", $$v)
      },
      expression: "brokerSubmitForm.businessPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "companyEmail",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Company email *",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.companyEmail),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "companyEmail", $$v)
      },
      expression: "brokerSubmitForm.companyEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Website"
    },
    model: {
      value: (_vm.brokerSubmitForm.url),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "url", $$v)
      },
      expression: "brokerSubmitForm.url"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "stateOfInc",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state of incorporation *"
    },
    model: {
      value: (_vm.brokerSubmitForm.stateOfInc),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "stateOfInc", $$v)
      },
      expression: "brokerSubmitForm.stateOfInc"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Select state of incorporation",
      "value": "",
      "disabled": ""
    }
  }), _vm._v(" "), _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "yearsInBusiness",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Years in business *",
      "maxlength": 16
    },
    model: {
      value: (_vm.brokerSubmitForm.yearsInBusiness),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "yearsInBusiness", $$v)
      },
      expression: "brokerSubmitForm.yearsInBusiness"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "prop": "tin",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "EIN (Tax ID number) *",
      "maxlength": 10
    },
    on: {
      "input": _vm.handleTinInput
    },
    model: {
      value: (_vm.brokerSubmitForm.tin),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "tin", $$v)
      },
      expression: "brokerSubmitForm.tin"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "industry",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select industry type *"
    },
    model: {
      value: (_vm.brokerSubmitForm.industry),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "industry", $$v)
      },
      expression: "brokerSubmitForm.industry"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Select industry type",
      "value": "",
      "disabled": ""
    }
  }), _vm._v(" "), _vm._l((_vm.industries), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "structure",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select company structure *"
    },
    model: {
      value: (_vm.brokerSubmitForm.structure),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "structure", $$v)
      },
      expression: "brokerSubmitForm.structure"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Select company structure",
      "value": "",
      "disabled": ""
    }
  }), _vm._v(" "), _vm._l((_vm.structures), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "revenue"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Annual revenue",
      "maxlength": 16
    },
    model: {
      value: (_vm.brokerSubmitForm.revenue),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "revenue", $$v)
      },
      expression: "brokerSubmitForm.revenue"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "margin-bottom-0",
    attrs: {
      "label": "Business description",
      "prop": "description",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Please include details by describing your business, revenue stream, and specifics to the need for this loan. For Equipment Financing, please also add how this equipment loan will increase your revenue (i.e. debt service coverage ratio before and after loan) and what is the timing you will start to see a contribution to your revenue?",
      "rows": 3
    },
    model: {
      value: (_vm.brokerSubmitForm.description),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "description", $$v)
      },
      expression: "brokerSubmitForm.description"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px",
      "margin-bottom": "30px"
    }
  }, [_vm._v("Business Owners")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "First name *",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.firstName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "firstName", $$v)
      },
      expression: "brokerSubmitForm.firstName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 4,
      "lg": 4
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Middle name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.middleName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "middleName", $$v)
      },
      expression: "brokerSubmitForm.middleName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "lastName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Last name *",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.lastName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "lastName", $$v)
      },
      expression: "brokerSubmitForm.lastName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "ssn",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Social security number *",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 9
    },
    model: {
      value: (_vm.brokerSubmitForm.ssn),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "ssn", $$v)
      },
      expression: "brokerSubmitForm.ssn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "streetAddress",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Home address *",
      "maxlength": 40
    },
    model: {
      value: (_vm.brokerSubmitForm.streetAddress),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "streetAddress", $$v)
      },
      expression: "brokerSubmitForm.streetAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 4,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "streetAddressLine2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Address Line 2",
      "maxlength": 40
    },
    model: {
      value: (_vm.brokerSubmitForm.streetAddressLine2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "streetAddressLine2", $$v)
      },
      expression: "brokerSubmitForm.streetAddressLine2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cityName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "City name *",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.cityName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "cityName", $$v)
      },
      expression: "brokerSubmitForm.cityName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "state",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state *"
    },
    model: {
      value: (_vm.brokerSubmitForm.state),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "state", $$v)
      },
      expression: "brokerSubmitForm.state"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Select state",
      "value": "",
      "disabled": ""
    }
  }), _vm._v(" "), _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "zipCode",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Zip code *",
      "maxlength": 5
    },
    model: {
      value: (_vm.brokerSubmitForm.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "zipCode", $$v)
      },
      expression: "brokerSubmitForm.zipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cellPhone",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "Phone *",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.brokerSubmitForm.cellPhone),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "cellPhone", $$v)
      },
      expression: "brokerSubmitForm.cellPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Email *",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.email),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "email", $$v)
      },
      expression: "brokerSubmitForm.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "jobTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Title (if applicable)",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.jobTitle),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "jobTitle", $$v)
      },
      expression: "brokerSubmitForm.jobTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessOwnership",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Business ownership % *",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.brokerSubmitForm.businessOwnership),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessOwnership", $$v)
      },
      expression: "brokerSubmitForm.businessOwnership"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px",
      "margin-bottom": "30px"
    },
    on: {
      "click": function($event) {
        _vm.showAddOwner = !_vm.showAddOwner
      }
    }
  }, [_vm._v("Add owner"), _c('i', {
    staticClass: "fa",
    class: {
      'fa-chevron-up': _vm.showAddOwner,
      'fa-chevron-down': !_vm.showAddOwner
    },
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddOwner),
      expression: "showAddOwner"
    }]
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstName2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "First name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.firstName2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "firstName2", $$v)
      },
      expression: "brokerSubmitForm.firstName2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 4,
      "lg": 4
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Middle name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.middleName2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "middleName2", $$v)
      },
      expression: "brokerSubmitForm.middleName2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "lastName2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Last name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.lastName2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "lastName2", $$v)
      },
      expression: "brokerSubmitForm.lastName2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "ssn2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Social security number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 9
    },
    model: {
      value: (_vm.brokerSubmitForm.ssn2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "ssn2", $$v)
      },
      expression: "brokerSubmitForm.ssn2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "streetAddress2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Home address",
      "maxlength": 40
    },
    model: {
      value: (_vm.brokerSubmitForm.streetAddress2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "streetAddress2", $$v)
      },
      expression: "brokerSubmitForm.streetAddress2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 4,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "streetAddress2Line2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Address Line 2",
      "maxlength": 40
    },
    model: {
      value: (_vm.brokerSubmitForm.streetAddress2Line2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "streetAddress2Line2", $$v)
      },
      expression: "brokerSubmitForm.streetAddress2Line2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cityName2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "City name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.cityName2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "cityName2", $$v)
      },
      expression: "brokerSubmitForm.cityName2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "state2"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state"
    },
    model: {
      value: (_vm.brokerSubmitForm.state2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "state2", $$v)
      },
      expression: "brokerSubmitForm.state2"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Select state",
      "value": "",
      "disabled": ""
    }
  }), _vm._v(" "), _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "zipCode2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Zip code",
      "maxlength": 5
    },
    model: {
      value: (_vm.brokerSubmitForm.zipCode2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "zipCode2", $$v)
      },
      expression: "brokerSubmitForm.zipCode2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cellPhone2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "Phone",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.brokerSubmitForm.cellPhone2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "cellPhone2", $$v)
      },
      expression: "brokerSubmitForm.cellPhone2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.email2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "email2", $$v)
      },
      expression: "brokerSubmitForm.email2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "jobTitle2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Title (if applicable)",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.jobTitle2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "jobTitle2", $$v)
      },
      expression: "brokerSubmitForm.jobTitle2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessOwnership2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Business ownership %",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "min": 0,
      "max": 100 - _vm.brokerSubmitForm.businessOwnership
    },
    model: {
      value: (_vm.brokerSubmitForm.businessOwnership2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessOwnership2", $$v)
      },
      expression: "brokerSubmitForm.businessOwnership2"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px",
      "margin-bottom": "30px"
    }
  }, [_vm._v("Vendor (if applicable)")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "vendorName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Vendor name"
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorName", $$v)
      },
      expression: "brokerSubmitForm.vendorName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "vendorPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Vendor phone",
      "maxlength": 10
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorPhone),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorPhone", $$v)
      },
      expression: "brokerSubmitForm.vendorPhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "vendorAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 40,
      "placeholder": "Vendor address"
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorAddress),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorAddress", $$v)
      },
      expression: "brokerSubmitForm.vendorAddress"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "vendorCity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 30,
      "placeholder": "City"
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorCity),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorCity", $$v)
      },
      expression: "brokerSubmitForm.vendorCity"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "vendorState"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state"
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorState),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorState", $$v)
      },
      expression: "brokerSubmitForm.vendorState"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Select state",
      "value": "Select state",
      "disabled": ""
    }
  }), _vm._v(" "), _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "vendorZipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Zip code",
      "maxlength": 5
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorZipCode),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorZipCode", $$v)
      },
      expression: "brokerSubmitForm.vendorZipCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "Contact first name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Contact first name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorContactFirstName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorContactFirstName", $$v)
      },
      expression: "brokerSubmitForm.vendorContactFirstName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "Contact last name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Contact last name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorContactLastName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorContactLastName", $$v)
      },
      expression: "brokerSubmitForm.vendorContactLastName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "Contact email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Contact email",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorContactEmail),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorContactEmail", $$v)
      },
      expression: "brokerSubmitForm.vendorContactEmail"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Equipment amount",
      "prop": "equipmentAmount",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.brokerSubmitForm.equipmentAmount),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "equipmentAmount", $$v)
      },
      expression: "brokerSubmitForm.equipmentAmount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Equipment status",
      "prop": "equipmentStatus",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Equipment Status *"
    },
    model: {
      value: (_vm.brokerSubmitForm.equipmentStatus),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "equipmentStatus", $$v)
      },
      expression: "brokerSubmitForm.equipmentStatus"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Equipment Type",
      "prop": "equipmentType",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Equipment Type *"
    },
    model: {
      value: (_vm.brokerSubmitForm.equipmentType),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "equipmentType", $$v)
      },
      expression: "brokerSubmitForm.equipmentType"
    }
  }, _vm._l((_vm.equipmentTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Reason for equipment purchase",
      "prop": "reasonForEquipment",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Reason for equipment purchase *"
    },
    model: {
      value: (_vm.brokerSubmitForm.reasonForEquipment),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "reasonForEquipment", $$v)
      },
      expression: "brokerSubmitForm.reasonForEquipment"
    }
  }, _vm._l((_vm.equipmentTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "amount",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Loan amount *"
    },
    model: {
      value: (_vm.brokerSubmitForm.amount),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "amount", $$v)
      },
      expression: "brokerSubmitForm.amount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "term"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Desired loan term"
    },
    model: {
      value: (_vm.brokerSubmitForm.term),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "term", $$v)
      },
      expression: "brokerSubmitForm.term"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Desired loan term",
      "value": "Desired loan term",
      "disabled": ""
    }
  }), _vm._v(" "), _vm._l((_vm.equipmentLoanTermS), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text.concat(' months'),
        "value": item.value
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "wantDownPayment",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Do you want to pay a down payment *"
    },
    model: {
      value: (_vm.brokerSubmitForm.wantDownPayment),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "wantDownPayment", $$v)
      },
      expression: "brokerSubmitForm.wantDownPayment"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Do you want to pay a down payment",
      "value": "",
      "disabled": ""
    }
  }), _vm._v(" "), _vm._l((_vm.downPaymentOrNot), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "margin-bottom-0",
    attrs: {
      "label": "Equipment description",
      "prop": "equipmentDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.brokerSubmitForm.equipmentDesc),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "equipmentDesc", $$v)
      },
      expression: "brokerSubmitForm.equipmentDesc"
    }
  })], 1), _vm._v(" "), (_vm.frontApplyId != '') ? _c('div', [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px",
      "margin-bottom": "30px"
    }
  }, [_vm._v("Documents")])]), _vm._v(" "), (_vm.uploadedDocuments.length > 0) ? _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.uploadedDocuments,
      "align": "left"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "file_name",
      "label": "File Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "file_category",
      "label": "File Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.reviewFile(scope.row.file_url)
            }
          }
        }, [_vm._v("Review")])]
      }
    }], null, false, 2978399178)
  })], 1), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "review-section col-lg-12 row",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "amcredit-text"
  }, [_vm._v("Upload any documents related to you or your business. Files must be PDF, JPEG, PNG, DOC or XLS, 25mb max.")]), _vm._v(" "), _c('div', {
    staticClass: "remove-padding col-lg-12"
  }, [_c('multiple-uploads', {
    key: _vm.fileUploadComponentKey,
    on: {
      "ready": function (childVal) {
        _vm.uploadedFiles = childVal
      }
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "margin-bottom-0",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Notes",
      "rows": 3
    },
    model: {
      value: (_vm.brokerSubmitForm.brokerNote),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "brokerNote", $$v)
      },
      expression: "brokerSubmitForm.brokerNote"
    }
  })], 1)], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12"
  }, [_c('div', {
    staticClass: "step-form__main pt-3"
  }, [_c('div', {
    staticClass: "step-form__btn-container"
  }, [_c('el-button', {
    staticClass: "rounded-pill blue px-5",
    staticStyle: {
      "float": "center"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitApplicationForm
    }
  }, [_vm._v("Update")])], 1), _vm._v(" "), _c('br')])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31453668"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/brokerCenter/ApplicationDetail.vue
// module id = 1964
// module chunks = 5